import {Component, Vue, Watch} from 'vue-property-decorator';
import {  ServiceType, Service } from '@/products-and-services/ProductsAndServicesModels';
import { CrossSale, CrossSaleAudienceType, CrossSaleCatalogItem,  CrossSaleGroup, CrossSalePageRoutes } from '@/products-and-services/CrossSaleModels';
import { Route } from 'vue-router';

@Component
    export default class CrossSalesMixin  extends Vue {
        @Watch('$route', { immediate: true})
        onRouteChange(newVal: Route) {
            if ((newVal.name && newVal.name !== this.$store.state.currentRoute && CrossSalePageRoutes[newVal.name])) {
                this.$store.commit('setCurrentRoute', newVal.name);     
                this.$store.dispatch('loadCrossSales', {pageId: CrossSalePageRoutes[newVal.name], audience: this.crossSaleAudienceType});
            }
        }

        get crossSaleAudienceType() {
            if (window.location.pathname.includes('residential')) {
                return CrossSaleAudienceType.RESIDENCE;
            }
            return CrossSaleAudienceType.BUSINESS;
        }
    
        get crossSales(): CrossSaleGroup[] {
            const serviceTypes: ServiceType[] = this.$store.getters.getAvailableServices();
            const crossSales: CrossSale[] = this.$store.state.crossSales;
            const filteredCrossSales = crossSales.filter(c => c.audience === this.crossSaleAudienceType || c.audience === CrossSaleAudienceType.BOTH);
            if (filteredCrossSales && filteredCrossSales.length > 0) {
                return filteredCrossSales.filter(crossSaleItem => crossSaleItem.contentToDisplay.length > 0).map(crossSale => {
                    // need to check serviceTypes here to ensure the location of the user has the serviceTypes we are attempting to cross sale
                    let availableContent: CrossSaleCatalogItem[] = crossSale.contentToDisplay.filter(content =>
                        serviceTypes && serviceTypes.find(serviceType => serviceType.id === content.serviceTypeId.toString()));
                    availableContent = this.filterProductsThatDontExistInService(availableContent);
                    return {title: crossSale.title,contentToDisplay: availableContent.slice(0,crossSale.contentDisplayLimit)};
                })
            }
            return [];
        }

        private filterProductsThatDontExistInService(availableContent: CrossSaleCatalogItem[]): CrossSaleCatalogItem[] {
            let filteredContent = availableContent
            if (this.$store.state.shoppingCartData.selectedOptions && this.$store.state.shoppingCartData.selectedOptions.services.length > 0) {
                const servicesInCart: Service[] = this.$store.state.shoppingCartData.selectedOptions.services;
                // this will be responsible for filtering out products that don't exist for the users selected service
                filteredContent = availableContent.filter(crossSaleCatalogItem => {
                    // find service in cart
                    const serviceInCart = servicesInCart.find(service => service.serviceTypeId === crossSaleCatalogItem.serviceTypeId.toString());
                    if (crossSaleCatalogItem.productId && serviceInCart) {
                        // find the matching available service to check the products
                        const availableServiceType: ServiceType | undefined = this.$store.state.shoppingCartData.availableOptions?.serviceTypes?.find(
                            (serviceType: ServiceType) => serviceInCart.serviceTypeId === serviceType.id);
                        const serviceToVerify = availableServiceType?.services && availableServiceType.services.find(service => service.serviceId === serviceInCart.serviceId);
                        // filter out this cross sale item if the selected service does not have associated products
                        if (serviceToVerify && serviceToVerify.categories) {
                            if (!serviceToVerify.categories.find(category => category.products.some(product => product.productId === crossSaleCatalogItem.productId.toString()))) {
                                return false;
                            }
                        }
                    }
                    return true;
                })
            }
            return filteredContent;
        }

}